// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'handshake';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='m15.217 10.643-4.155.825M2.76 10.65h1.838l2.632 2.955a1.056 1.056 0 0 0 .75.345 34.633 34.633 0 0 0 4.305-3.667c.083-.233-.075-.465-.217-.66l-1.883-2.43M7.935 5.31l-.263-.225a1.62 1.62 0 0 0-.922-.3c-.2 0-.399.038-.585.113L2.812 6.233' />
    <path d='M.563 4.95h1.5a.75.75 0 0 1 .75.69v4.815a.75.75 0 0 1-.75.683h-1.5m16.875 0h-1.5a.75.75 0 0 1-.75-.683V5.64a.75.75 0 0 1 .75-.69h1.5M11.063 6.9l-2.588.855a1.208 1.208 0 0 1-1.5-.645 1.223 1.223 0 0 1 .555-1.605l2.52-1.267c.246-.126.519-.19.795-.188.204.001.407.037.6.105l3.75 1.365' />
  </g>
);

export const viewBox = '0 0 18 18';
